"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for control_client
 * @enhanceable
 * @public
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScsControlClient = void 0;
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck
const grpcWeb = __importStar(require("grpc-web"));
const controlclient_pb = __importStar(require("./controlclient_pb"));
class ScsControlClient {
    constructor(hostname, credentials, options) {
        this.methodDescriptorCreateCache = new grpcWeb.MethodDescriptor('/control_client.ScsControl/CreateCache', grpcWeb.MethodType.UNARY, controlclient_pb._CreateCacheRequest, controlclient_pb._CreateCacheResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._CreateCacheResponse.deserializeBinary);
        this.methodDescriptorDeleteCache = new grpcWeb.MethodDescriptor('/control_client.ScsControl/DeleteCache', grpcWeb.MethodType.UNARY, controlclient_pb._DeleteCacheRequest, controlclient_pb._DeleteCacheResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._DeleteCacheResponse.deserializeBinary);
        this.methodDescriptorListCaches = new grpcWeb.MethodDescriptor('/control_client.ScsControl/ListCaches', grpcWeb.MethodType.UNARY, controlclient_pb._ListCachesRequest, controlclient_pb._ListCachesResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._ListCachesResponse.deserializeBinary);
        this.methodDescriptorFlushCache = new grpcWeb.MethodDescriptor('/control_client.ScsControl/FlushCache', grpcWeb.MethodType.UNARY, controlclient_pb._FlushCacheRequest, controlclient_pb._FlushCacheResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._FlushCacheResponse.deserializeBinary);
        this.methodDescriptorCreateSigningKey = new grpcWeb.MethodDescriptor('/control_client.ScsControl/CreateSigningKey', grpcWeb.MethodType.UNARY, controlclient_pb._CreateSigningKeyRequest, controlclient_pb._CreateSigningKeyResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._CreateSigningKeyResponse.deserializeBinary);
        this.methodDescriptorRevokeSigningKey = new grpcWeb.MethodDescriptor('/control_client.ScsControl/RevokeSigningKey', grpcWeb.MethodType.UNARY, controlclient_pb._RevokeSigningKeyRequest, controlclient_pb._RevokeSigningKeyResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._RevokeSigningKeyResponse.deserializeBinary);
        this.methodDescriptorListSigningKeys = new grpcWeb.MethodDescriptor('/control_client.ScsControl/ListSigningKeys', grpcWeb.MethodType.UNARY, controlclient_pb._ListSigningKeysRequest, controlclient_pb._ListSigningKeysResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._ListSigningKeysResponse.deserializeBinary);
        this.methodDescriptorCreateIndex = new grpcWeb.MethodDescriptor('/control_client.ScsControl/CreateIndex', grpcWeb.MethodType.UNARY, controlclient_pb._CreateIndexRequest, controlclient_pb._CreateIndexResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._CreateIndexResponse.deserializeBinary);
        this.methodDescriptorDeleteIndex = new grpcWeb.MethodDescriptor('/control_client.ScsControl/DeleteIndex', grpcWeb.MethodType.UNARY, controlclient_pb._DeleteIndexRequest, controlclient_pb._DeleteIndexResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._DeleteIndexResponse.deserializeBinary);
        this.methodDescriptorListIndexes = new grpcWeb.MethodDescriptor('/control_client.ScsControl/ListIndexes', grpcWeb.MethodType.UNARY, controlclient_pb._ListIndexesRequest, controlclient_pb._ListIndexesResponse, (request) => {
            return request.serializeBinary();
        }, controlclient_pb._ListIndexesResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname;
        this.credentials_ = credentials;
        this.options_ = options;
    }
    createCache(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/CreateCache', request, metadata || {}, this.methodDescriptorCreateCache, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/CreateCache', request, metadata || {}, this.methodDescriptorCreateCache);
    }
    deleteCache(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/DeleteCache', request, metadata || {}, this.methodDescriptorDeleteCache, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/DeleteCache', request, metadata || {}, this.methodDescriptorDeleteCache);
    }
    listCaches(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/ListCaches', request, metadata || {}, this.methodDescriptorListCaches, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/ListCaches', request, metadata || {}, this.methodDescriptorListCaches);
    }
    flushCache(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/FlushCache', request, metadata || {}, this.methodDescriptorFlushCache, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/FlushCache', request, metadata || {}, this.methodDescriptorFlushCache);
    }
    createSigningKey(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/CreateSigningKey', request, metadata || {}, this.methodDescriptorCreateSigningKey, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/CreateSigningKey', request, metadata || {}, this.methodDescriptorCreateSigningKey);
    }
    revokeSigningKey(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/RevokeSigningKey', request, metadata || {}, this.methodDescriptorRevokeSigningKey, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/RevokeSigningKey', request, metadata || {}, this.methodDescriptorRevokeSigningKey);
    }
    listSigningKeys(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/ListSigningKeys', request, metadata || {}, this.methodDescriptorListSigningKeys, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/ListSigningKeys', request, metadata || {}, this.methodDescriptorListSigningKeys);
    }
    createIndex(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/CreateIndex', request, metadata || {}, this.methodDescriptorCreateIndex, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/CreateIndex', request, metadata || {}, this.methodDescriptorCreateIndex);
    }
    deleteIndex(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/DeleteIndex', request, metadata || {}, this.methodDescriptorDeleteIndex, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/DeleteIndex', request, metadata || {}, this.methodDescriptorDeleteIndex);
    }
    listIndexes(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/control_client.ScsControl/ListIndexes', request, metadata || {}, this.methodDescriptorListIndexes, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/control_client.ScsControl/ListIndexes', request, metadata || {}, this.methodDescriptorListIndexes);
    }
}
exports.ScsControlClient = ScsControlClient;
